import type { ShouldRevalidateFunction } from 'react-router';
import { SESSION_REFRESH_PATH } from '@legalzoom/my-account-core';

export const shouldRevalidate: ShouldRevalidateFunction = ({
  currentParams,
  nextParams,
  nextUrl,
  formMethod,
  formAction,
  defaultShouldRevalidate,
}) => {
  // ?reload forces revalidation (used after onboarding, account switching, etc.)
  if (nextUrl.searchParams.has('reload')) {
    return true;
  }

  // Session-refresh PUT/POST should never cascade revalidation to other routes.
  if (
    formMethod &&
    formMethod.toLocaleLowerCase() !== 'get' &&
    formAction?.toLocaleLowerCase() === SESSION_REFRESH_PATH
  ) {
    return false;
  }

  // For other mutations, respect default behavior so loaders
  // re-run and reflect the action result.
  if (formMethod && formMethod.toLocaleLowerCase() !== 'get') {
    return defaultShouldRevalidate;
  }

  // On GET navigations, skip revalidation if the account hasn't changed.
  // All account-scoped data is keyed on accountId, so there's nothing
  // new to fetch when it stays the same.
  // Exception: documentUuid changes require revalidation for document-specific data
  if (
    currentParams.accountId === nextParams.accountId &&
    currentParams.documentUuid === nextParams.documentUuid
  ) {
    return false;
  }

  return defaultShouldRevalidate;
};
